import { useLocale } from '../../contexts/LocaleContext';
import '../AllCss/SkipToContent.css';

function SkipToContent() {
  const { t } = useLocale();

  return (
    <a href="#main-content" className="skip-to-content">
      {t('common.skipToContent')}
    </a>
  );
}

export default SkipToContent;
